import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useEffect, useMemo, useCallback } from 'react';
import useZipcodeValidator from './useZipcodeValidator';
import useGlobalZipcode from './useGlobalZipcode';
import { LocalStorageGeoInfo } from '../utils/constants';
import { removeItemFromLocalStorage } from '../../utils/localStorageUtils';
var useZipcode = function useZipcode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$withCity = _ref.withCity,
    withCity = _ref$withCity === void 0 ? false : _ref$withCity,
    _ref$ssr = _ref.ssr,
    ssr = _ref$ssr === void 0 ? false : _ref$ssr;
  if (!ssr && typeof window === 'undefined') {
    return {};
  }
  var _useGlobalZipcode = useGlobalZipcode({
      withCity: withCity,
      ssr: ssr
    }),
    globalZip = _useGlobalZipcode.globalZip,
    globalZipInfo = _useGlobalZipcode.globalZipInfo,
    userInputZip = _useGlobalZipcode.userInputZip,
    updateGlobalZip = _useGlobalZipcode.updateGlobalZip;
  var _useZipcodeValidator = useZipcodeValidator(),
    validateZip = _useZipcodeValidator.validateZip,
    validateGeolocation = _useZipcodeValidator.validateGeolocation;
  var initialInternalState = {
    zipcode: globalZip,
    zipcodeInfo: globalZipInfo || {},
    zipcodeValid: !!(globalZip && globalZipInfo && globalZipInfo.zip),
    zipcodeError: false
  };
  var _useState = useState(initialInternalState),
    _useState2 = _slicedToArray(_useState, 2),
    internalState = _useState2[0],
    setZipState = _useState2[1];
  var zipcode = internalState.zipcode,
    zipcodeInfo = internalState.zipcodeInfo,
    zipcodeValid = internalState.zipcodeValid,
    zipcodeError = internalState.zipcodeError;
  useEffect(function () {
    setZipState(initialInternalState);
  }, [globalZip, globalZipInfo]);
  var setZip = function setZip(zipcode) {
    return setZipState(_objectSpread(_objectSpread({}, internalState), {}, {
      zipcode: zipcode,
      zipcodeValid: false,
      zipcodeError: false
    }));
  };
  var resetZip = function resetZip() {
    return setZipState(initialInternalState);
  };
  var updateZip = useCallback(function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(event) {
      var zipcode, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            zipcode = event.target.value;
            if (!(!zipcode || zipcode.match(/^[0-9]*$/))) {
              _context.next = 7;
              break;
            }
            setZip(zipcode);
            _context.next = 5;
            return validateZip(zipcode);
          case 5:
            result = _context.sent;
            if (result) {
              setZipState(result);
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [setZip, setZipState, validateZip]);
  var requestZip = useCallback(function () {
    navigator.geolocation.getCurrentPosition(function () {
      var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(result) {
        var locationInfoByLatLng, _result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return validateGeolocation(result.coords);
            case 2:
              locationInfoByLatLng = _context2.sent;
              if (!locationInfoByLatLng.isValid) {
                _context2.next = 9;
                break;
              }
              setZip(locationInfoByLatLng.zip);
              _context2.next = 7;
              return validateZip(locationInfoByLatLng.zip);
            case 7:
              _result = _context2.sent;
              if (_result) {
                setZipState(_result);
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  }, [validateGeolocation, validateZip, setZip, setZipState]);
  var submitZip = useCallback(function () {
    if (zipcodeValid) {
      removeItemFromLocalStorage(LocalStorageGeoInfo);
      updateGlobalZip(zipcodeInfo);
    }
  }, [updateGlobalZip, zipcodeValid, zipcodeInfo]);
  var location = useMemo(function () {
    return {
      userInputZip: userInputZip,
      zipcode: zipcode,
      zipcodeInfo: zipcodeInfo,
      state: zipcodeInfo.stateNonLower,
      city: zipcodeInfo.city,
      county: zipcodeInfo.county,
      subCounty: zipcodeInfo.subCounty,
      isMajorMarket: zipcodeInfo.isMajorMarket,
      zipcodeValid: zipcodeValid,
      zipcodeError: zipcodeError,
      requestZip: requestZip,
      updateZip: updateZip,
      submitZip: submitZip,
      resetZip: resetZip
    };
  }, [userInputZip, zipcode, zipcodeInfo, zipcodeValid, zipcodeError, requestZip, updateZip, submitZip, resetZip]);
  return location;
};
useZipcode.displayName = 'useZipcode';
export default useZipcode;